import { useEffect, useState } from 'react';

export function useQueryString() {
  const [queryString, setQueryString] = useState<URLSearchParams>(new URLSearchParams());
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setQueryString(params);
  }, []);
  return queryString;
}

export function useQueryStringParameter(parameter: string) {
  const queryString = useQueryString();
  return queryString.get(parameter);
}

export function useQueryStringParameters(...parameters: string[]) {
  const queryString = useQueryString();
  return parameters.map((parameter) => queryString.get(parameter));
}
